import React, { Fragment } from "react";
import externalLink from "../../../assets/images/external-link.png";

const PrintYarnList = props => {
  let stylePage = listValue => {
    let action =
      (props.styleRights.web.edit && "edit") ||
      (props.rights.web.view && "view");
    let newSearch = "?" + new URLSearchParams({
      action: action,
      _id: listValue._id,
      hash: `seleted${listValue.referenceCode.split("-").join("")}`
    }).toString()
    window.open(`/StylePage${newSearch}#seleted${listValue.referenceCode.split("-").join("")}`, "_blank")
    // window.open(`/StylePage${newSearch}`, "_blank")
  };

  return (
    <Fragment>
      <tr>
        {props.list !== undefined &&
          Array.isArray(props.list) &&
          props.list.length > 0 &&
          Object.keys(props.list[0]).map(listValue => {
            return (
              listValue !== "ID" &&
              listValue !== "COMMENTS" && (
                <td className="report-header text-center border">
                  {listValue}
                </td>
              )
            );
          })}
      </tr>
      {props.list !== undefined &&
        Array.isArray(props.list) &&
        props.list.length > 0 &&
        props.list.map(listValue => {
          return (
            <Fragment>
              <tr>
                {Object.keys(listValue).map(listName => {
                  return listName === "IMAGE" ? (
                    <td className="d-flex align-items-center justify-content-between">
                      <img
                        onClick={() =>
                          listValue[listName] &&
                          props.modalData(listValue[listName])
                        }
                        style={{ width: " 50px", height: "50px" }}
                        src={`${listValue[listName]}`}
                      />
                    </td>
                  ) : listName === "STYLE NO" ? (
                    <td className="d-flex align-items-center justify-content-between">
                      {listValue[listName].referenceCode}
                      {listValue[listName].referenceCode && <img
                        title={`Go To Style Page Of ${listValue[listName].referenceCode}`}
                        className={"cursor-hover"}
                        style={{
                          cursor: "pointer",
                          marginTop: "-1px",
                          verticalAlign: "top",
                          marginLeft: "5px"
                        }}
                        onClick={() => stylePage(listValue[listName])}
                        src={externalLink}
                      />}
                    </td>
                  ) : (
                        listName !== "ID" && listName !== "COMMENTS" && (
                          <td>{listValue[listName]}</td>
                        )
                      );
                })}
              </tr>
            </Fragment>
          );
        })}
      null
    </Fragment>
  );
};

export default PrintYarnList;


// WEBPACK FOOTER //
// ./src/components/Report/reports/printYarn.js